import { InternationalLogisticEndpoints } from '@/modules/seller-management/international-logistic/api/internationalLogisticEndpoints'

/**
 * International Logistic endpoint instance
 * International Logistic Arrival api class with different api path
 */
export const internationalLogisticEndpoints =
  new InternationalLogisticEndpoints()
